import { PropsWithChildren, HTMLAttributes } from 'react';
import styled, { css } from 'styled-components';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';

export interface GridCellProps extends HTMLAttributes<HTMLDivElement> {
  area?: string;
  mobile?: boolean;
}

const gridAreaStyle = (area?: string) =>
  area !== undefined
    ? css`
        grid-area: ${area};
      `
    : '';

const hideOnMobile = (mobile?: boolean) =>
  mobile !== true
    ? css`
        &&& {
          @media (max-width: ${MOBILE_BREAKPOINT}px) {
            display: none;
          }
        }
      `
    : '';

const GridCellBaseStyled = styled.div<GridCellProps>`
  ${(props) => gridAreaStyle(props.area)}
  ${(props) => hideOnMobile(props.mobile)}
`;

export function GridCellBase({
  area,
  mobile = false,
  children,
  ...rest
}: PropsWithChildren<GridCellProps>) {
  return (
    <GridCellBaseStyled {...rest} area={area} mobile={mobile}>
      {children}
    </GridCellBaseStyled>
  );
}

export default GridCellBase;
